import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { viewPhotoSvc } from './PtmSlideShowSvc';



import teacherImage from "./images/classTeacher.jpg";
import principalImage from "./images/principal.jpg";


function WelcomeSlide(props) {
  const [welcomeObj, setWelcomeObj] = useState();
  const [sectionId, setSectionId] = useState(0)
  const [ptmId, setPtmId] = useState(0)
  const [tchPhoto, setTchPhoto] = useState('')
  const [priPhoto, setPriPhoto] = useState('')
  const [loader, setLoader] = useState('none')

  useEffect(() => {

    // console.log("props.data in useEffect welcomeSlide", props.data);
    setWelcomeObj(props.data);
    setPtmId(props.ptmId)
    setSectionId(props.sectionId)
    if (props?.welcomeObj?.clsTchId != 0) {
      viewPhoto('tch', props.data?.clsTchId)
    }
    if (props.data.principalId != 0) {
      viewPhoto('pri', props.data?.principalId)
    }
  }, [props]);

  function viewPhoto(role, userId) {
    // console.log('userId', userId)
    setLoader('block')
    if (userId != undefined) {
      if (role == 'tch') {
        viewPhotoSvc(userId, cbViewTchPhotoResp)
      } else {
        viewPhotoSvc(userId, cbViewPriPhotoResp)
      }
    }
  }

  function cbViewTchPhotoResp(url, response) {
    // console.log(response)
    if (!url) {
      if (response.SvcStatus === 'Failure') {
        toast.error(response.SvcMsg)
      }
    } else {
      setTchPhoto(url)
    }
    setLoader('none')
  }

  function cbViewPriPhotoResp(url, response) {
    // console.log(url)
    if (!url) {
      if (response.SvcStatus === 'Failure') {
        toast.error(response.SvcMsg)
      }
    } else {
      setPriPhoto(url)
    }
    setLoader('none')
  }
  const onErrorTch = () => {
    // var errorURL = `https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350`
    // var errorURL = window.appURL + '/no-image.png'
    // setTchPhoto(errorURL)
    setTchPhoto(teacherImage);
  }
  const onErrorPri = () => {
    // var errorURL = `https://images.pexels.com/photos/20787/pexels-photo.jpg?auto=compress&cs=tinysrgb&h=350`
    // var errorURL = window.appURL + '/no-image.png'
    // setPriPhoto(errorURL)
    setPriPhoto(principalImage);
  }
  return (
    <div className="col-sm-12" style={{ height: '100vh', boxSizing: 'border-box' }}>
      <div className="row" style={{ height: '45vh', marginTop: '5vh' }}>
        <div className="text-center" style={{ color: '#ff5c00', fontSize: "9rem", fontWeight: "bold" }}>{welcomeObj?.school}</div>
        <br />
        <div className="text-center" style={{ color: '#FBFFFF', fontSize: "5rem", fontWeight: "bold" }}>welcomes you to</div>
        <div className="text-center" style={{ color: '#FBFFFF', fontSize: "7rem", fontWeight: "bold" }}>PTM for class {welcomeObj?.clsSection}</div>
      </div>
      <div className="row" style={{ height: '50vh' }}>
        <div className="col-sm-3">
          <h5 className="text-center" style={{ color: '#00FFFF' }}>Principal</h5>
          <img
            style={{
              display: 'block',
              width: '100%',
              maxWidth: '100%',
              height: 'auto',
              border: 0,
              objectFit: 'fill'
            }}
            id='pri_pic'
            src={priPhoto}
            alt='img'
            onError={e => onErrorPri()}
          />
        </div>
        <div className="col-sm-6" style={{ marginTop: "10vh" }}>

          {/* <h2 className="text-center" style={{ color: '#FBFFFF' }}>Class Teacher</h2> */}
          <div className="text-center" style={{ color: '#E6E6FA', fontSize: "5rem" }}>Class Teacher</div>
          <div className="text-center" style={{ color: '#00BFFF', fontSize: "5rem" }}>{welcomeObj?.clsTch}</div>
          {/* <div className="text-center" style={{ color: '#AEC6CF', fontSize: "5rem" }}>Class Teacher</div>
            <div className="text-center" style={{ color: '#F08080', fontSize: "5rem" }}>{welcomeObj?.clsTch}</div> */}
          {/* <div className="text-center" style={{ color: '#255A59', fontSize: "5rem" }}>Class Teacher</div>
            <div className="text-center" style={{ color: '#FBFFFF', fontSize: "5rem" }}>{welcomeObj?.clsTch}</div> */}

        </div>
        <div className="col-sm-3">
          {/* <h5 className="text-center" style={{ color: '#fff01f' }}>Class Teacher</h5> */}
          <h5 className="text-center" style={{ color: '#00FFFF' }}>Class Teacher</h5>
          <img
            style={{
              display: 'block',
              width: '100%',
              maxWidth: '100%',
              height: 'auto',
              border: 0,
              objectFit: 'fill', marginBottom: 0
            }}
            id='tch_pic'
            src={tchPhoto}
            alt='img'
            onError={e => onErrorTch()}
          /></div>
      </div>
    </div>
  )
}

export default WelcomeSlide